import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
import { register } from './serviceWorker';
import { changeUpdate } from './state';
import store from './config/store/store';

import { msalInstance, initializeMsal } from './config/auth.config';

const container = document.getElementById('root');
const root = createRoot(container as never);

initializeMsal().then(() => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );

  register({
    onUpdate: registration => {
      store.dispatch(changeUpdate(registration) as never);
    },
  });
});
